import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  submit: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },

  endButton: {
    fontSize: theme.size.sm,
    width: 'auto'
  },

  input: {
    outline: 'none',
    border: 'none',
    width: '100%',
    minHeight: '40px'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1rem',
    marginBottom: '1.5rem',
    boxSizing: 'border-box',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  convoList: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down(960)]: {
      paddingBottom: '64px'
    }
  }
}))

export default useStyles
